"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EUserLevels = void 0;
var EUserLevels;
(function (EUserLevels) {
    EUserLevels[EUserLevels["Guest"] = 0] = "Guest";
    EUserLevels[EUserLevels["User"] = 50] = "User";
    EUserLevels[EUserLevels["Admin"] = 100] = "Admin";
})(EUserLevels = exports.EUserLevels || (exports.EUserLevels = {}));
